export const withCacheBuster = (url)=>{
    if (!url || url.includes('X-Amz-Signature')) {
        return url;
    }
    return url.includes('?') ? `${url}&v2` : `${url}?v2`;
};
export const getThumbnailUrl = (imageUrl)=>{
    if (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.includes('thumb_')) {
        return imageUrl;
    }
    // a presigned key cannot be rewritten: the signature covers the object name
    if (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.includes('X-Amz-Signature')) {
        return imageUrl;
    }
    if (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.includes('https://assets.rocketlane.com/')) {
        return imageUrl;
    }
    /**
   * We are going to display the thumbnail instead of teh actual pic in the avatar
   * This is done temporarily on the FE; need to get thumbURL from the BE
   * Need to generally apply this for other avatars like project/company etc
   */ const imgUrlSplit = imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.split('/');
    if (imgUrlSplit) {
        imgUrlSplit[imgUrlSplit.length - 1] = `thumb_${imgUrlSplit[imgUrlSplit.length - 1]}`;
    }
    const thumbUrl = imgUrlSplit === null || imgUrlSplit === void 0 ? void 0 : imgUrlSplit.join('/');
    return thumbUrl;
};
